var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6444 3.86914C10.1556 3.86914 7.28857 6.64258 7.28857 10.0925V19.8333C7.28857 20.2054 7.59946 20.5098 7.97942 20.5098H11.5718C11.9518 20.5098 12.2627 20.2054 12.2627 19.8333V10.363C12.2627 9.61895 12.8844 9.01014 13.6444 9.01014C14.4043 9.01014 15.0261 9.61895 15.0261 10.363V19.8333C15.0261 20.2054 15.3369 20.5098 15.7169 20.5098H19.3093C19.6893 20.5098 20.0001 20.2054 20.0001 19.8333V10.0925C20.0001 6.6764 17.1677 3.86914 13.6444 3.86914Z",
    fill: "#505F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48705 0.892578C1.10535 0.892578 0 1.97472 0 3.32741C0 4.68009 1.10535 5.76224 2.48705 5.76224C3.86874 5.76224 4.97409 4.68009 4.97409 3.32741C4.97409 1.97472 3.86874 0.892578 2.48705 0.892578Z",
    fill: "#505F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28325 7.04785H0.690846C0.310881 7.04785 0 7.35225 0 7.7243V19.8327C0 20.2048 0.310881 20.5092 0.690846 20.5092H4.28325C4.66321 20.5092 4.97409 20.2048 4.97409 19.8327V7.7243C4.97409 7.35225 4.66321 7.04785 4.28325 7.04785Z",
    fill: "#505F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/Linkedin icon.1daec1e01bac07e4cd477cd20867f7fe.svg";
export { ForwardRef as ReactComponent };